import { Router, RouteLocationNormalizedLoaded } from 'vue-router'
import { device } from '@/store'

const SHARE_GOODS_BACK_HOME = 'shareGoodsBackHome'
const AUTH_PAGES = ['Login', 'AutoLogin', 'SelectCompany', 'SelectMeeting', 'SelectShop']

function queryValue(value: unknown) {
  if (Array.isArray(value)) return value[0] ? String(value[0]) : ''
  return value === undefined || value === null ? '' : String(value)
}

export function hasShareGoodsBackHome() {
  return sessionStorage.getItem(SHARE_GOODS_BACK_HOME) === '1'
}

/** 分享商品页留下之后，把当前历史换成首页，再打开原来的商品 */
export async function padShareGoodsHistory(router: Router, route: RouteLocationNormalizedLoaded) {
  if (!device.isWeChatMini) return
  if (!(Number(queryValue(route.query.fair_id)) > 0)) return
  if (hasShareGoodsBackHome()) return
  const query = { ...route.query }
  sessionStorage.setItem(SHARE_GOODS_BACK_HOME, '1')
  device.setLoading(true)
  try {
    await router.replace({ name: 'Home' })
    await router.push({
      name: 'GoodsDetail',
      query,
    })
  } finally {
    device.setLoading(false)
  }
}

/** 从垫出来的首页再返回到登录或选企业时，退出网页 */
export function shareGoodsBackGuard(router: Router) {
  let popping = false
  window.addEventListener(
    'popstate',
    () => {
      popping = true
    },
    true
  )

  router.beforeEach((to, from, next) => {
    const isPop = popping
    popping = false
    if (
      isPop &&
      device.isWeChatMini &&
      hasShareGoodsBackHome() &&
      from.name === 'Home' &&
      AUTH_PAGES.indexOf(String(to.name)) >= 0
    ) {
      try {
        wx.miniProgram.navigateBack()
      } catch (error) {}
      return next(false)
    }
    return next()
  })
}
